import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJava = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 13,
			width: 12,
			height: 1,
			rx: .5,
			fill: "#E66D17"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.5 3.6C2.5 3.31172 2.50039 3.12559 2.51196 2.98392C2.52306 2.84809 2.5419 2.79773 2.5545 2.773C2.60243 2.67892 2.67892 2.60243 2.773 2.5545C2.79773 2.5419 2.84809 2.52306 2.98392 2.51196C3.12559 2.50039 3.31172 2.5 3.6 2.5H11.4C11.6883 2.5 11.8744 2.50039 12.0161 2.51196C12.1519 2.52306 12.2023 2.5419 12.227 2.5545C12.3211 2.60243 12.3976 2.67892 12.4455 2.773L12.8864 2.54834L12.4455 2.773C12.4581 2.79773 12.4769 2.84809 12.488 2.98392C12.4996 3.12559 12.5 3.31172 12.5 3.6V6.5C12.5 7.93194 12.4946 8.53707 12.3493 9.016C12.01 10.1346 11.1346 11.01 10.016 11.3493C9.53707 11.4946 8.93194 11.5 7.5 11.5C6.06806 11.5 5.46293 11.4946 4.984 11.3493C3.8654 11.01 2.99003 10.1346 2.65071 9.016C2.50543 8.53707 2.5 7.93194 2.5 6.5V3.6Z",
			fill: "#FFF4EB",
			stroke: "#E66D17"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 2.5H14.5C14.7761 2.5 15 2.72386 15 3V4.18121C15 4.78125 14.6424 5.32356 14.0909 5.55993L12.5 6.24173V2.5Z",
			stroke: "#E66D17"
		})
	]
});
export default SvgJava;
